import React from 'react';
import { mapStateToProps, mapDispatchToProps, StateManagementProps } from '../../utils/addReduxProps';
import { connect } from 'react-redux';
import { withStyles, WithStyles, Theme } from '@material-ui/core';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import colors from '../../utils/colors';
import { Grid } from '@material-ui/core';
import VehicleSummary, { VehicleSummaryProps } from '../vehicle-overview/VehicleSummary';
import VehicleImage from '../vehicle-overview/VehicleImage';
import HillsIcon from '../../assets/icons/hills';
import MountainsIcon from '../../assets/icons/mountains';
import MotorwayIcon from '../../assets/icons/motorway';
import { Link, RouteProps } from 'react-router-dom';
import { Location } from 'history';
import Exit from '@material-ui/icons/Close';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export interface PreviewComponentProps {

}

export interface PreviewComponentState {
	background: number;
}

export const classes: (theme: Theme) => Record<string, CSSProperties> = (theme: Theme) => {
	return {
		wrapper: {
			backgroundColor: colors.grayBackground,
			height: '100%',
			background: 'white',
		},

		bikeWrapper: {
			height: '80%',
			position: 'relative' as "relative",
		},

		background: {
			width: '100%',
		},
		rootIcons: {
			display: 'flex',
			flexDirection: 'row' as "row",
			justifyContent: 'center',
			color: 'white',
			'& > h3': {
				lineHeight: '48px',
			}
		},
		contentWrapper: {
			width: '100%',
			position: 'absolute' as "absolute",
			bottom: '15px',
			padding: '15px',
			boxSizing: 'border-box' as "border-box",
			height: 'calc(100% - 60px)',
			top: '-10px',
		},
		headerGrid: {
			padding: '15px',
		},
		closePreviewBtn: {
			color: 'white',
		},
		selected: {
			background: theme.palette.primary.main,
			borderRadius: '4px',
		},
		iconWrapper: {
			marginLeft: '5px',
		}
	}
};

type PreviewProps = PreviewComponentProps & StateManagementProps & WithStyles & WithNamespaces & RouteProps;

class PreviewComponent extends React.Component<PreviewProps, PreviewComponentState> {
	state = {
		background: 0
	}

	handleBackgroundChanged(id: number) {
		this.setState({ background: id })
	}

	render() {
		const {
			classes,
			t,
			location,
			appliedSetup,
			appliedParts,
			totalPrice,
			models: { ShowPricesInConfigurator: hasPrices },
			selectedModel,
		} = this.props;
		const motorcycleBackground = {
			background: `url(${process.env.PUBLIC_URL}/images/pho_backdrop${this.state.background + 1}.jpg) center/cover`,
			height: '63%',
		};

		const vehicleSummaryProps: VehicleSummaryProps = {
			hasPrices,
			appliedSetup,
			appliedParts,
			totalPrice,
			model: selectedModel,
		};
		const { state } = location as Location;
		const closePreviewUrl = state && state.from ? state.from : '/page-not-found';
		const { wrapper, headerGrid, rootIcons, bikeWrapper, background, contentWrapper, closePreviewBtn, selected, iconWrapper } = classes;

		return (
			<section className={wrapper} id="bike-preview">
				<Grid container direction='column' className="full-height">
					{/* HEADER GRID */}
					<Grid item className={headerGrid}>
						<Grid container direction='row'>
							<Grid item className={rootIcons}>
								<h3>{t('preview.background')}</h3>
								{[<HillsIcon />, <MountainsIcon />, <MotorwayIcon />].map((Icon: React.ReactNode, idx: number) => {
									return (<div key={idx} className={iconWrapper}>
										<div className={this.state.background === idx ? selected : ''} onClick={this.handleBackgroundChanged.bind(this, idx)}>
											{Icon}
										</div>
									</div>);
								})}
							</Grid>
							<Grid item className="grow"></Grid>
							<Grid item><Link to={closePreviewUrl}><Exit className={closePreviewBtn}></Exit></Link></Grid>
						</Grid>
					</Grid>
					{/* BODY WITH PICTURE */}
					<Grid item className={`${bikeWrapper} grow`}>
						<div style={motorcycleBackground} className={`full-height ${background}`}>
							<div className={contentWrapper}>
								<VehicleImage arrowStyle={{ left: '12px' }} />
								<VehicleSummary {...vehicleSummaryProps}></VehicleSummary>
							</div>
						</div>
					</Grid>
				</Grid>
			</section >
		);
	}
}

export default withNamespaces()(withStyles(classes)(connect(mapStateToProps, mapDispatchToProps)(PreviewComponent)));
